import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

import type { ChartType } from '@/lib/analytics/charts/chart.type';
// Lib
import { SIZE_50 } from '@/lib/gridElements/size';
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';
import { Trans } from '@/components/tools/translation';

export const followerGrowthConfig: ChartType<typeof LineChart> = {
    title: 'chart.tiktok.follower_growth',
    margin: { left: -20, right: 10 },
    name: {
        date: 'date',
        estimated: 'estimated_data',
        value: 'chart.tiktok.follower_growth_name',
        evolution: 'evolution',
        avg: 'chart.tiktok.follower_growth'
    },
    id: 'followers_growth',
    color: {
        value: 'blue',
        avg: 'gray',
        estimated: 'blue',
        unavailable: 'gray'
    },
    legendTypes: {
        value: 'line',
        unavailable: 'square'
    },
    valueFormat: classicFormatMaxTwoDigits,
    tooltip: (
        <Trans
            i18nKey="analytics:chart.tiktok.tooltip_follower_growth"
            components={{ br: <br /> }}
        />
    ),
    size: SIZE_50,
    type: 'chart',
    noDataToken: 'no_data_period',
    element: LineChart,
    dashboardEligibleNetworks: [TIKTOK_BUSINESS]
};
